/**
 * posts-grid.js
 *
 * Adds the 'load more' functionality to the posts grid.s
 */
import './posts-grid.scss';
import localizedText from '../../includes/localized_text.json';

(($) => {
	$('.posts-grid__wrapper').on(
		'click',
		'.posts-grid__load-more-link',
		function (e) {
			e.preventDefault();
			const nextPage = $(this).attr('href');
			const locale = window.locale || 'en';
			const loadingText = localizedText.post_grid_loading[locale];
			$.ajax({
				url: nextPage,
				type: 'GET',
				beforeSend: () => {
					$(this).text(loadingText);
				},
				success: (data) => {
					if (data) {
						$(this).parent().remove();
						const parser = new DOMParser();
						const response = parser.parseFromString(
							data,
							'text/html'
						);

						const moreResults = $(response)
							.find('.posts-grid')
							.addClass('added-posts');
						const resultsGrid = $('.posts-grid__wrapper');
						$('div.grid-item').css('display', 'block');

						resultsGrid.append(moreResults);
					} else {
						$(this).parent().remove();
					}
				},
			});
		}
	);
})(jQuery);
